import type { Lang } from "../../../../../shared/locales";
import { readCatalogs } from "../../../../../shared/catalog";
import { CORE } from "./core";
import { FLOWS } from "./flows";
import { LANDING } from "./landing";
import { PUBLIC } from "./public";
import { REST } from "./rest";

import { type AddedLang } from "../../../../../shared/locales";
export { ADDED_LANGS, type AddedLang } from "../../../../../shared/locales";

export const CATALOGS = readCatalogs([CORE, FLOWS, LANDING, PUBLIC, REST].join("\n"));
export const hasNewCatalog = (lang: Lang): lang is AddedLang => Object.hasOwn(CATALOGS, lang);
